import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FinalChecklistService {
  
  constructor(
    private http: HttpClient, 
    private configService: ConfigService, 
    private router: Router
  ) {}

  GetSocietyData(iSocietyDetailsId: number, iSocietyDetailsTranID: number): Observable<any> {
    const url = `${this.configService.getApiUrl()}/FinalChecklist/GetChecklistSociety/${iSocietyDetailsId}/${iSocietyDetailsTranID}`;
    
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('Error occurred while fetching society data:', err);
        return throwError(() => new Error('Failed to retrieve society data.'));
      })
    );
  }
    // Method for Add  Society type

    addSocietyType(payload: any): Observable<any> {

      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddUpdateSocietyType`;
      return this.http.post<any>(apiUrl, payload).pipe(
        map((response) => response),
        catchError((err) => {
          return throwError(() => new Error('Something went wrong while adding the Society type.'));
        })
      );
    }
    getSocietyTypeDetails(id: number): Observable<any[]> {
      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietyTypeRecord/${id}`;
      return this.http.post<any[]>(apiUrl, id);
    }
    
    
    
// Method for Delete Allot Auditor
deleteSocietyType(id: number): Observable<any> {

  const url = `${this.configService.getApiUrl()}/FinalChecklist/DeleteSocietyTypeRecord/${id}`;

  return this.http.post(url,id).pipe(
    catchError((error) => {
      console.error('Error deleting audit:', error);
      throw error;
    })
  );
}
    // Method for get All List data
  getAllSocietyType(data:any) {
  
    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietyAll`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
    
  }
  
  // Method for Add Comman Society 

  addBuilding(building: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddSocietyDetail`;
    return this.http.post<any>(apiUrl, building).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the building.'));
      })
    );
  }


   // Method for Add AR Rejetection

rejectionAR(data: any): Observable<any> {
  const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/RejectCancelAuditorRequest`;
  return this.http.post<any>(apiUrl, data).pipe(
    map((response) => response),
    catchError((err) => {
      return throwError(() => new Error('Something went wrong while rejecting the request.'));
    })
  );
}
sendbackAR(data: any): Observable<any> {
  const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/DynamicSendBackMoveForward`;
  return this.http.post<any>(apiUrl, data).pipe(
    map((response) => response),
    catchError((err) => {
      return throwError(() => new Error('Something went wrong while sendback the request.'));
    })
  );
}

  addEmp(empList: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddMemberandEmployeeDetails`;
    return this.http.post<any>(apiUrl, empList).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the Employee.'));
      })
    );
  }
  addAudit(auditList: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddAuditDetailinCheckList`;
    return this.http.post<any>(apiUrl, auditList).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the Audit.'));
      })
    );
  }
  addBalancesheet(balanceList: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddCheckListbalancesheet`;
    return this.http.post<any>(apiUrl, balanceList).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the balance sheet.'));
      })
    );
  }
  addotherList(otherList: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/SocietyOtherParameterSubmit`;
    return this.http.post<any>(apiUrl, otherList).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the other list data.'));
      })
    );
  }

   allotDepartmentAuditor(model:any){
        const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/SaveAllotAuditor`;
        return this.http.post<any>(apiUrl,model).pipe(
          map((response) => {
            return response;
          }),
          catchError((err) => {
            return throwError(() => new Error('Re-assign request failed.'));
          })
        );
      }
 
 
  addservices(requestData: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/SocietyServiceAdd`;
    return this.http.post<any>(apiUrl, requestData).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the services.'));
      })
    );
  }
    // Service method to call the head API
    getheadDatas(headType: number): Observable<any> {
      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetCheckListHead/${headType}`;
    
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          console.error("Error in getheadDatas:", error);
          return throwError(() => new Error('Failed to retrieve checklist head data.'));
        })
      );
    }
    // Service method to call the GellALl API
    getlistDatas(iSocietyDetailsTranID: number): Observable<any> {
      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetAllCheckListData/${iSocietyDetailsTranID}`;
    
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          console.error("Error in getheadDatas:", error);
          return throwError(() => new Error('Failed to retrieve checklist  data.'));
        })
      );
    }
     // Service method to call the getfieldsDatas API
     getfieldsDatas(SocietyCheckID: number): Observable<any> {
      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietyServiceFields/${SocietyCheckID}`;
    
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          console.error("Error in getheadDatas:", error);
          return throwError(() => new Error('Failed to retrieve checklist fields data.'));
        })
      );
    }
       // Service method to call the getfieldsDatas API
       getsubfieldsDatas(SocietyCheckID: number): Observable<any> {
        const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietySubField/${SocietyCheckID}`;
      
        return this.http.get<any>(apiUrl).pipe(
          map((response) => {
            return response;
          }),
          catchError((error) => {
            console.error("Error in getheadDatas:", error);
            return throwError(() => new Error('Failed to retrieve sub fields data.'));
          })
        );
      }
     // Service method to call the getservicesDatas API
     getservicesDatas(iSocietyTransID:number): Observable<any> {
      const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietyServices/${iSocietyTransID}`;
    
      return this.http.get<any>(apiUrl).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          console.error("Error in getheadDatas:", error);
          return throwError(() => new Error('Failed to retrieve Services.'));
        })
      );
    }
    
  // Service method to call the getsubheadDatas API
  getsubheadDatas(headID:any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetCheckListSubHead/${headID}`;  // Your API endpoint

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;  // Return the API response as it is
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve head Data.'));
      })
    );
  }
}
